'use client';

import classNames from 'classnames';

import { PropsWithClassname } from '@/app/types';
import { Donation } from '@/app/api';

import DonationRecord from '@/app/components/DonationRecord/DonationRecord';

interface DonationListProps extends PropsWithClassname {
  donations: Donation[];
}

const DonationList = ({ donations, className }: DonationListProps) => {
  return (
    <div className={classNames(className)}>
      {donations.map((donation) => (
        <DonationRecord
          key={donation.id}
          id={donation.id!}
          username={donation.donorName!}
          date={donation.createdAt!}
          message={donation.isCommentVisible && !!donation.donorComment ? donation.donorComment : undefined}
          amountInCents={donation.amountInCents!}
        />
      ))}
    </div>
  );
};

export default DonationList;
